import { useState, useEffect, useCallback } from "react";
import "./TouristSlider.css";

const slides = [
  {
    image: `${process.env.PUBLIC_URL}/tourist-places/om-beach.png`,
    title: "Om Beach",
    description:
      "Named after its natural Om shape, this iconic beach offers golden sands, stunning sunsets, and a serene coastal vibe.",
  },
  {
    image: `${process.env.PUBLIC_URL}/tourist-places/kudle-beach.jpg`,
    title: "Kudle Beach",
    description:
      "A pristine crescent-shaped paradise with crystal-clear waters, perfect for relaxation and water sports.",
  },
  {
    image: `${process.env.PUBLIC_URL}/tourist-places/mirjan-fort.jpg`,
    title: "Mirjan Fort",
    description:
      "A 16th-century architectural marvel draped in lush greenery, offering a glimpse into the region's rich history.",
  },
  {
    image: `${process.env.PUBLIC_URL}/tourist-places/half-moon-beach.jpg`,
    title: "Half Moon Beach",
    description:
      "A secluded gem accessible only by trek or boat, surrounded by dramatic cliffs and tropical forest.",
  },
  {
    image: `${process.env.PUBLIC_URL}/tourist-places/yana-caves.jpg`,
    title: "Yana Caves",
    description:
      "Towering black crystalline rock formations rising from the Western Ghats forest — a geological wonder.",
  },
  {
    image: `${process.env.PUBLIC_URL}/tourist-places/vibhooti-falls.png`,
    title: "Vibhooti Falls",
    description:
      "A majestic multi-tiered waterfall cascading through lush rainforest, a nature lover's dream.",
  },
  {
    image: `${process.env.PUBLIC_URL}/tourist-places/mahabaleshwar-temple.jpg`,
    title: "Mahabaleshwar Temple",
    description:
      "One of the holiest Shiva temples in India, tucked in Gokarna town with stunning Dravidian architecture and spiritual serenity.",
  },
  {
    image: `${process.env.PUBLIC_URL}/tourist-places/paradise-beach.jpg`,
    title: "Paradise Beach",
    description:
      "A hidden gem accessible only by boat or forest trek — pristine sands, turquoise waters, and untouched natural beauty.",
  },
  {
    image: `${process.env.PUBLIC_URL}/tourist-places/gokarna-main-beach.jpg`,
    title: "Gokarna Main Beach",
    description:
      "The vibrant heart of Gokarna — colorful fishing boats, golden sands, and a perfect blend of culture and coastal charm.",
  },
  {
    image: `${process.env.PUBLIC_URL}/tourist-places/murdeshwar-temple.jpg`,
    title: "Murdeshwar Temple",
    description:
      "Home to the world's second-tallest Shiva statue, dramatically perched on the Arabian Sea coastline — a breathtaking sight.",
  },
];

function TouristSlider() {
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const goTo = useCallback((index) => {
    setCurrent(index);
  }, []);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  }, []);

  // Auto-slide every 5 seconds
  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [isPaused, next]);

  return (
    <section className="tourist-slider" id="tourist-places">
      <div className="tourist-slider__header reveal">
        <h2>
          Explore <span>Gokarna</span>
        </h2>
        <p>
          Discover breathtaking tourist destinations in and around Gokarna —
          ride there on our bikes!
        </p>
      </div>

      <div
        className="tourist-slider__viewport"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {/* Slides */}
        <div className="tourist-slider__track">
          {slides.map((slide, i) => (
            <div
              key={i}
              className={`tourist-slider__slide ${i === current ? "tourist-slider__slide--active" : ""
                }`}
            >
              <img src={slide.image} alt={slide.title} loading="lazy" />
              <div className="tourist-slider__overlay">
                <h3>{slide.title}</h3>
                <p>{slide.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Arrows */}
        <button
          className="tourist-slider__arrow tourist-slider__arrow--prev"
          onClick={prev}
          aria-label="Previous slide"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <button
          className="tourist-slider__arrow tourist-slider__arrow--next"
          onClick={next}
          aria-label="Next slide"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 6L15 12L9 18"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {/* Dots */}
        <div className="tourist-slider__dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`tourist-slider__dot ${i === current ? "tourist-slider__dot--active" : ""
                }`}
              onClick={() => goTo(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default TouristSlider;
